// Voice options by provider
export const voiceOptions = {
  google: [
    { id: 'despina', name: 'Despina', gender: 'female', accent: 'American' },
    { id: 'wavenet-a', name: 'Wavenet A', gender: 'female', accent: 'American' },
    { id: 'wavenet-b', name: 'Wavenet B', gender: 'male', accent: 'American' },
    { id: 'wavenet-c', name: 'Wavenet C', gender: 'female', accent: 'British' },
    { id: 'wavenet-d', name: 'Wavenet D', gender: 'male', accent: 'British' },
    { id: 'wavenet-e', name: 'Wavenet E', gender: 'female', accent: 'Australian' },
    { id: 'wavenet-f', name: 'Wavenet F', gender: 'female', accent: 'Indian' },
    { id: 'neural2-a', name: 'Neural2 A', gender: 'female', accent: 'American' },
    { id: 'neural2-c', name: 'Neural2 C', gender: 'male', accent: 'American' },
    { id: 'studio-o', name: 'Studio O', gender: 'female', accent: 'American' },
    { id: 'studio-q', name: 'Studio Q', gender: 'male', accent: 'American' },
    // Russian voices - Standard
    { id: 'ru-RU-Standard-A', name: 'Olga (Standard)', gender: 'female', accent: 'Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Standard-B', name: 'Pavel (Standard)', gender: 'male', accent: 'Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Standard-C', name: 'Elena (Standard)', gender: 'female', accent: 'Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Standard-D', name: 'Sergei (Standard)', gender: 'male', accent: 'Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Standard-E', name: 'Irina (Standard)', gender: 'female', accent: 'Russian', language: 'Russian', age: 'adult' },
    // Russian voices - Wavenet (Neural)
    { id: 'ru-RU-Wavenet-A', name: 'Ekaterina (Neural)', gender: 'female', accent: 'Moscow Russian', language: 'Russian', age: 'young adult' },
    { id: 'ru-RU-Wavenet-B', name: 'Dmitri (Neural)', gender: 'male', accent: 'Moscow Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Wavenet-C', name: 'Marina (Neural)', gender: 'female', accent: 'Moscow Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Wavenet-D', name: 'Aleksei (Neural)', gender: 'male', accent: 'Moscow Russian', language: 'Russian', age: 'mature' },
    { id: 'ru-RU-Wavenet-E', name: 'Yulia (Neural)', gender: 'female', accent: 'St. Petersburg', language: 'Russian', age: 'young adult' },
    // Russian voices - Neural2 (Latest)
    { id: 'ru-RU-Neural2-A', name: 'Anastasia (Neural2)', gender: 'female', accent: 'Moscow Russian', language: 'Russian', age: 'young adult' },
    { id: 'ru-RU-Neural2-B', name: 'Mikhail (Neural2)', gender: 'male', accent: 'Moscow Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Neural2-C', name: 'Viktoria (Neural2)', gender: 'female', accent: 'Standard Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-Neural2-D', name: 'Andrei (Neural2)', gender: 'male', accent: 'Standard Russian', language: 'Russian', age: 'mature' },
  ],
  elevenlabs: [
    // ============ AMERICAN ACCENTS ============
    { id: 'rachel', name: 'Rachel', gender: 'female', accent: 'American', description: 'Calm, warm voice' },
    { id: 'bella', name: 'Bella', gender: 'female', accent: 'American', description: 'Soft, gentle voice' },
    { id: 'elli', name: 'Elli', gender: 'female', accent: 'American', description: 'Young, friendly voice' },
    { id: 'domi', name: 'Domi', gender: 'female', accent: 'American', description: 'Strong, confident voice' },
    { id: 'nicole', name: 'Nicole', gender: 'female', accent: 'American', description: 'Soft, whisper-like' },
    { id: 'serena', name: 'Serena', gender: 'female', accent: 'American', description: 'Pleasant, calm' },
    { id: 'freya', name: 'Freya', gender: 'female', accent: 'American', description: 'Expressive, dynamic' },
    { id: 'adam', name: 'Adam', gender: 'male', accent: 'American', description: 'Deep, authoritative' },
    { id: 'antoni', name: 'Antoni', gender: 'male', accent: 'American', description: 'Calm, well-modulated' },
    { id: 'josh', name: 'Josh', gender: 'male', accent: 'American', description: 'Young, energetic' },
    { id: 'arnold', name: 'Arnold', gender: 'male', accent: 'American', description: 'Crisp, articulate' },
    { id: 'sam', name: 'Sam', gender: 'male', accent: 'American', description: 'Raspy, unique' },
    { id: 'liam', name: 'Liam', gender: 'male', accent: 'American', description: 'Articulate, clear' },
    { id: 'ethan', name: 'Ethan', gender: 'male', accent: 'American', description: 'Young adult' },
    { id: 'thomas', name: 'Thomas', gender: 'male', accent: 'American', description: 'Calm, reassuring' },
    
    // ============ BRITISH ACCENTS ============
    { id: 'glinda', name: 'Glinda', gender: 'female', accent: 'British', description: 'Warm, storytelling' },
    { id: 'lily', name: 'Lily', gender: 'female', accent: 'British', description: 'Warm, narrating' },
    { id: 'dorothy', name: 'Dorothy', gender: 'female', accent: 'British', description: 'Pleasant, friendly' },
    { id: 'daniel', name: 'Daniel', gender: 'male', accent: 'British', description: 'Authoritative, deep' },
    { id: 'dave', name: 'Dave', gender: 'male', accent: 'British', description: 'Conversational, Essex' },
    { id: 'george', name: 'George', gender: 'male', accent: 'British', description: 'Warm, narrator' },
    { id: 'brian', name: 'Brian', gender: 'male', accent: 'British', description: 'Professional narrator' },
    
    // ============ AUSTRALIAN ACCENTS ============
    { id: 'charlie', name: 'Charlie', gender: 'male', accent: 'Australian', description: 'Natural, conversational' },
    { id: 'james', name: 'James', gender: 'male', accent: 'Australian', description: 'Calm, composed' },
    
    // ============ IRISH ACCENTS ============
    { id: 'fin', name: 'Fin', gender: 'male', accent: 'Irish', description: 'Calm, soothing' },
    
    // ============ SWEDISH ACCENTS ============
    { id: 'mimi', name: 'Mimi', gender: 'female', accent: 'Swedish', description: 'Cute, animated' },
    { id: 'charlotte', name: 'Charlotte', gender: 'female', accent: 'Swedish', description: 'Seductive, confident' },
    
    // ============ SOUTHERN US ACCENTS ============
    { id: 'grace', name: 'Grace', gender: 'female', accent: 'Southern American', description: 'Warm, southern belle' },
    
    // ============ TRANSATLANTIC ============
    { id: 'callum', name: 'Callum', gender: 'male', accent: 'Transatlantic', description: 'Video game character' },
    
    // ============ RUSSIAN VOICES ============
    { id: 'natasha-ru', name: 'Natasha', gender: 'female', accent: 'Moscow Russian', language: 'Russian', description: 'Professional, warm' },
    { id: 'ivan-ru', name: 'Ivan', gender: 'male', accent: 'Moscow Russian', language: 'Russian', description: 'Deep, authoritative' },
    { id: 'katya-ru', name: 'Katya', gender: 'female', accent: 'St. Petersburg', language: 'Russian', description: 'Cultured, elegant' },
    { id: 'boris-ru', name: 'Boris', gender: 'male', accent: 'Standard Russian', language: 'Russian', description: 'Mature, professional' },
    { id: 'anya-ru', name: 'Anya', gender: 'female', accent: 'Moscow Russian', language: 'Russian', description: 'Young, friendly' },
    { id: 'nikita-ru', name: 'Nikita', gender: 'male', accent: 'Standard Russian', language: 'Russian', description: 'Young adult, energetic' },
    { id: 'lena-ru', name: 'Lena', gender: 'female', accent: 'Southern Russian', language: 'Russian', description: 'Warm, regional' },
    { id: 'vladimir-ru', name: 'Vladimir', gender: 'male', accent: 'Moscow Russian', language: 'Russian', description: 'Mature, wise' },
    { id: 'elena-ru', name: 'Elena', gender: 'female', accent: 'Standard Russian', language: 'Russian', description: 'Strong, confident' },
    { id: 'dmitri-ru', name: 'Dmitri', gender: 'male', accent: 'Moscow Russian', language: 'Russian', description: 'Professional, clear' },
    { id: 'sergei-ru', name: 'Sergei', gender: 'male', accent: 'Standard Russian', language: 'Russian', description: 'Narrator, mature' },
    { id: 'olga-ru', name: 'Olga', gender: 'female', accent: 'Moscow Russian', language: 'Russian', description: 'Expressive' },
    { id: 'mikhail-ru', name: 'Mikhail', gender: 'male', accent: 'Standard Russian', language: 'Russian', description: 'Calm, well-spoken' },
    
    // ============ UZBEK VOICES ============
    { id: 'dilnoza-uz', name: 'Dilnoza', gender: 'female', accent: 'Tashkent Uzbek', language: 'Uzbek', description: 'Professional, warm' },
    { id: 'rustam-uz', name: 'Rustam', gender: 'male', accent: 'Tashkent Uzbek', language: 'Uzbek', description: 'Deep, authoritative' },
    { id: 'gulnora-uz', name: 'Gulnora', gender: 'female', accent: 'Samarkand Uzbek', language: 'Uzbek', description: 'Cultured, regional' },
    { id: 'akbar-uz', name: 'Akbar', gender: 'male', accent: 'Tashkent Uzbek', language: 'Uzbek', description: 'Mature, professional' },
    { id: 'malika-uz', name: 'Malika', gender: 'female', accent: 'Standard Uzbek', language: 'Uzbek', description: 'Young, friendly' },
    { id: 'timur-uz', name: 'Timur', gender: 'male', accent: 'Fergana Uzbek', language: 'Uzbek', description: 'Regional, energetic' },
    { id: 'nodira-uz', name: 'Nodira', gender: 'female', accent: 'Bukhara Uzbek', language: 'Uzbek', description: 'Traditional, warm' },
    { id: 'aziz-uz', name: 'Aziz', gender: 'male', accent: 'Standard Uzbek', language: 'Uzbek', description: 'Mature, wise' },
    
    // ============ SPANISH VOICES ============
    { id: 'sofia-es', name: 'Sofia', gender: 'female', accent: 'Castilian Spanish', language: 'Spanish', description: 'Professional, warm' },
    { id: 'carlos-es', name: 'Carlos', gender: 'male', accent: 'Castilian Spanish', language: 'Spanish', description: 'Deep, authoritative' },
    { id: 'isabella-es', name: 'Isabella', gender: 'female', accent: 'Mexican Spanish', language: 'Spanish', description: 'Friendly, warm' },
    { id: 'diego-es', name: 'Diego', gender: 'male', accent: 'Latin American Spanish', language: 'Spanish', description: 'Young, energetic' },
    
    // ============ FRENCH VOICES ============
    { id: 'amelie-fr', name: 'Amelie', gender: 'female', accent: 'Parisian French', language: 'French', description: 'Elegant, warm' },
    { id: 'pierre-fr', name: 'Pierre', gender: 'male', accent: 'Parisian French', language: 'French', description: 'Deep, sophisticated' },
    { id: 'chloe-fr', name: 'Chloe', gender: 'female', accent: 'Standard French', language: 'French', description: 'Young, friendly' },
    { id: 'jean-fr', name: 'Jean', gender: 'male', accent: 'Southern French', language: 'French', description: 'Regional, warm' },
    
    // ============ GERMAN VOICES ============
    { id: 'anna-de', name: 'Anna', gender: 'female', accent: 'High German', language: 'German', description: 'Professional, clear' },
    { id: 'hans-de', name: 'Hans', gender: 'male', accent: 'High German', language: 'German', description: 'Deep, authoritative' },
    { id: 'klara-de', name: 'Klara', gender: 'female', accent: 'Bavarian German', language: 'German', description: 'Warm, regional' },
    { id: 'felix-de', name: 'Felix', gender: 'male', accent: 'Austrian German', language: 'German', description: 'Young, friendly' },
    
    // ============ ARABIC VOICES ============
    { id: 'fatima-ar', name: 'Fatima', gender: 'female', accent: 'Modern Standard Arabic', language: 'Arabic', description: 'Professional, warm' },
    { id: 'ahmed-ar', name: 'Ahmed', gender: 'male', accent: 'Egyptian Arabic', language: 'Arabic', description: 'Deep, authoritative' },
    { id: 'layla-ar', name: 'Layla', gender: 'female', accent: 'Gulf Arabic', language: 'Arabic', description: 'Warm, friendly' },
    { id: 'omar-ar', name: 'Omar', gender: 'male', accent: 'Levantine Arabic', language: 'Arabic', description: 'Young, energetic' },
    
    // ============ HINDI VOICES ============
    { id: 'priya-hi', name: 'Priya', gender: 'female', accent: 'Standard Hindi', language: 'Hindi', description: 'Professional, warm' },
    { id: 'raj-hi', name: 'Raj', gender: 'male', accent: 'Standard Hindi', language: 'Hindi', description: 'Deep, authoritative' },
    { id: 'ananya-hi', name: 'Ananya', gender: 'female', accent: 'Mumbai Hindi', language: 'Hindi', description: 'Young, friendly' },
    { id: 'arjun-hi', name: 'Arjun', gender: 'male', accent: 'Delhi Hindi', language: 'Hindi', description: 'Professional, clear' },
    
    // ============ CHINESE VOICES ============
    { id: 'mei-zh', name: 'Mei', gender: 'female', accent: 'Mandarin Chinese', language: 'Chinese', description: 'Professional, warm' },
    { id: 'wei-zh', name: 'Wei', gender: 'male', accent: 'Mandarin Chinese', language: 'Chinese', description: 'Deep, authoritative' },
    { id: 'lin-zh', name: 'Lin', gender: 'female', accent: 'Beijing Mandarin', language: 'Chinese', description: 'Young, friendly' },
    { id: 'chen-zh', name: 'Chen', gender: 'male', accent: 'Standard Mandarin', language: 'Chinese', description: 'Professional, clear' },
    
    // ============ PORTUGUESE VOICES ============
    { id: 'maria-pt', name: 'Maria', gender: 'female', accent: 'Brazilian Portuguese', language: 'Portuguese', description: 'Warm, friendly' },
    { id: 'joao-pt', name: 'João', gender: 'male', accent: 'Brazilian Portuguese', language: 'Portuguese', description: 'Deep, professional' },
    { id: 'ana-pt', name: 'Ana', gender: 'female', accent: 'European Portuguese', language: 'Portuguese', description: 'Elegant, clear' },
    { id: 'pedro-pt', name: 'Pedro', gender: 'male', accent: 'European Portuguese', language: 'Portuguese', description: 'Professional' },
    
    // ============ ITALIAN VOICES ============
    { id: 'giulia-it', name: 'Giulia', gender: 'female', accent: 'Standard Italian', language: 'Italian', description: 'Warm, expressive' },
    { id: 'marco-it', name: 'Marco', gender: 'male', accent: 'Tuscan Italian', language: 'Italian', description: 'Deep, charming' },
    { id: 'sara-it', name: 'Sara', gender: 'female', accent: 'Roman Italian', language: 'Italian', description: 'Young, friendly' },
    { id: 'luca-it', name: 'Luca', gender: 'male', accent: 'Milanese Italian', language: 'Italian', description: 'Professional' },
  ],
  openai: [
    { id: 'alloy', name: 'Alloy', gender: 'neutral', accent: 'American' },
    { id: 'echo', name: 'Echo', gender: 'male', accent: 'American' },
    { id: 'fable', name: 'Fable', gender: 'female', accent: 'British' },
    { id: 'nova', name: 'Nova', gender: 'female', accent: 'American' },
    { id: 'shimmer', name: 'Shimmer', gender: 'female', accent: 'American' },
    { id: 'onyx', name: 'Onyx', gender: 'male', accent: 'American' },
    // OpenAI multilingual voices - work natively for Russian/Uzbek
    { id: 'alloy-multilingual', name: 'Alloy (Multilingual)', gender: 'neutral', accent: 'Multilingual', language: 'Multilingual' },
    { id: 'nova-multilingual', name: 'Nova (Multilingual)', gender: 'female', accent: 'Multilingual', language: 'Multilingual' },
    { id: 'echo-multilingual', name: 'Echo (Multilingual)', gender: 'male', accent: 'Multilingual', language: 'Multilingual' },
    { id: 'shimmer-multilingual', name: 'Shimmer (Multilingual)', gender: 'female', accent: 'Multilingual', language: 'Multilingual' },
    { id: 'onyx-multilingual', name: 'Onyx (Multilingual)', gender: 'male', accent: 'Multilingual', language: 'Multilingual' },
    { id: 'fable-multilingual', name: 'Fable (Multilingual)', gender: 'female', accent: 'Multilingual', language: 'Multilingual' },
  ],
  azure: [
    { id: 'jenny', name: 'Jenny', gender: 'female', accent: 'American' },
    { id: 'guy', name: 'Guy', gender: 'male', accent: 'American' },
    { id: 'aria', name: 'Aria', gender: 'female', accent: 'American' },
    { id: 'davis', name: 'Davis', gender: 'male', accent: 'American' },
    { id: 'sonia', name: 'Sonia', gender: 'female', accent: 'British' },
    { id: 'ryan', name: 'Ryan', gender: 'male', accent: 'British' },
    { id: 'natasha', name: 'Natasha', gender: 'female', accent: 'Australian' },
    { id: 'william', name: 'William', gender: 'male', accent: 'Australian' },
    // Russian voices - Azure Neural TTS
    { id: 'ru-RU-DariyaNeural', name: 'Dariya (Neural)', gender: 'female', accent: 'Moscow Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-SvetlanaNeural', name: 'Svetlana (Neural)', gender: 'female', accent: 'Standard Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-DmitryNeural', name: 'Dmitry (Neural)', gender: 'male', accent: 'Moscow Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-EkaterinaNeural', name: 'Ekaterina (Neural)', gender: 'female', accent: 'St. Petersburg', language: 'Russian', age: 'young adult' },
    { id: 'ru-RU-AlexeyNeural', name: 'Alexey (Neural)', gender: 'male', accent: 'Standard Russian', language: 'Russian', age: 'mature' },
    { id: 'ru-RU-IrinaNeural', name: 'Irina (Neural)', gender: 'female', accent: 'Moscow Russian', language: 'Russian', age: 'young' },
    { id: 'ru-RU-PavelNeural', name: 'Pavel (Neural)', gender: 'male', accent: 'Southern Russian', language: 'Russian', age: 'adult' },
    { id: 'ru-RU-AnnaNeural', name: 'Anna (Neural)', gender: 'female', accent: 'Standard Russian', language: 'Russian', age: 'mature' },
    // Uzbek voices - Azure Neural TTS
    { id: 'uz-UZ-MadinaNeural', name: 'Madina (Neural)', gender: 'female', accent: 'Tashkent Uzbek', language: 'Uzbek', age: 'adult' },
    { id: 'uz-UZ-SardorNeural', name: 'Sardor (Neural)', gender: 'male', accent: 'Tashkent Uzbek', language: 'Uzbek', age: 'adult' },
    { id: 'uz-UZ-DiloromNeural', name: 'Dilorom (Neural)', gender: 'female', accent: 'Samarkand Uzbek', language: 'Uzbek', age: 'young adult' },
    { id: 'uz-UZ-BekzodNeural', name: 'Bekzod (Neural)', gender: 'male', accent: 'Standard Uzbek', language: 'Uzbek', age: 'mature' },
    { id: 'uz-UZ-ZarinaNeural', name: 'Zarina (Neural)', gender: 'female', accent: 'Fergana Uzbek', language: 'Uzbek', age: 'young' },
    { id: 'uz-UZ-JamshidNeural', name: 'Jamshid (Neural)', gender: 'male', accent: 'Bukhara Uzbek', language: 'Uzbek', age: 'adult' },
  ],
  playht: [
    { id: 'matthew', name: 'Matthew', gender: 'male', accent: 'American' },
    { id: 'joanna', name: 'Joanna', gender: 'female', accent: 'American' },
    { id: 'ivy', name: 'Ivy', gender: 'female', accent: 'American' },
    { id: 'kendra', name: 'Kendra', gender: 'female', accent: 'American' },
    { id: 'kimberly', name: 'Kimberly', gender: 'female', accent: 'American' },
    { id: 'salli', name: 'Salli', gender: 'female', accent: 'American' },
    { id: 'joey', name: 'Joey', gender: 'male', accent: 'American' },
    { id: 'brian', name: 'Brian', gender: 'male', accent: 'British' },
    { id: 'emma', name: 'Emma', gender: 'female', accent: 'British' },
    // Russian voices - PlayHT
    { id: 'tatiana-ru', name: 'Tatiana', gender: 'female', accent: 'Moscow Russian', language: 'Russian', age: 'adult' },
    { id: 'maxim-ru', name: 'Maxim', gender: 'male', accent: 'Standard Russian', language: 'Russian', age: 'adult' },
    { id: 'olga-ru', name: 'Olga', gender: 'female', accent: 'St. Petersburg', language: 'Russian', age: 'young adult' },
    { id: 'igor-ru', name: 'Igor', gender: 'male', accent: 'Moscow Russian', language: 'Russian', age: 'mature' },
    { id: 'vera-ru', name: 'Vera', gender: 'female', accent: 'Southern Russian', language: 'Russian', age: 'adult' },
    { id: 'anton-ru', name: 'Anton', gender: 'male', accent: 'Standard Russian', language: 'Russian', age: 'young adult' },
    // Uzbek voices - PlayHT
    { id: 'feruza-uz', name: 'Feruza', gender: 'female', accent: 'Tashkent Uzbek', language: 'Uzbek', age: 'adult' },
    { id: 'shavkat-uz', name: 'Shavkat', gender: 'male', accent: 'Standard Uzbek', language: 'Uzbek', age: 'adult' },
    { id: 'nilufar-uz', name: 'Nilufar', gender: 'female', accent: 'Samarkand Uzbek', language: 'Uzbek', age: 'young adult' },
    { id: 'ulugbek-uz', name: 'Ulugbek', gender: 'male', accent: 'Fergana Uzbek', language: 'Uzbek', age: 'mature' },
  ],
  deepgram: [
    { id: 'aura-asteria', name: 'Asteria', gender: 'female', accent: 'American' },
    { id: 'aura-luna', name: 'Luna', gender: 'female', accent: 'American' },
    { id: 'aura-stella', name: 'Stella', gender: 'female', accent: 'American' },
    { id: 'aura-athena', name: 'Athena', gender: 'female', accent: 'British' },
    { id: 'aura-hera', name: 'Hera', gender: 'female', accent: 'American' },
    { id: 'aura-orion', name: 'Orion', gender: 'male', accent: 'American' },
    { id: 'aura-arcas', name: 'Arcas', gender: 'male', accent: 'American' },
    { id: 'aura-perseus', name: 'Perseus', gender: 'male', accent: 'American' },
    { id: 'aura-angus', name: 'Angus', gender: 'male', accent: 'Irish' },
    { id: 'aura-orpheus', name: 'Orpheus', gender: 'male', accent: 'American' },
    { id: 'aura-helios', name: 'Helios', gender: 'male', accent: 'British' },
    { id: 'aura-zeus', name: 'Zeus', gender: 'male', accent: 'American' },
    // Russian voices - Deepgram Aura
    { id: 'aura-nika-ru', name: 'Nika (Russian)', gender: 'female', accent: 'Moscow Russian', language: 'Russian', age: 'adult' },
    { id: 'aura-viktor-ru', name: 'Viktor (Russian)', gender: 'male', accent: 'Standard Russian', language: 'Russian', age: 'adult' },
    { id: 'aura-mila-ru', name: 'Mila (Russian)', gender: 'female', accent: 'St. Petersburg', language: 'Russian', age: 'young adult' },
    { id: 'aura-kirill-ru', name: 'Kirill (Russian)', gender: 'male', accent: 'Moscow Russian', language: 'Russian', age: 'mature' },
  ],
};

// LLM Models
export const llmModels = [
  // OpenAI
  { id: 'gpt-4.1-mini', name: 'GPT-4.1 Mini', provider: 'OpenAI', costPerMin: 0.105, description: 'Fast, cost-effective' },
  { id: 'gpt-4o', name: 'GPT-4o', provider: 'OpenAI', costPerMin: 0.15, description: 'Multimodal flagship' },
  { id: 'gpt-4o-mini', name: 'GPT-4o Mini', provider: 'OpenAI', costPerMin: 0.08, description: 'Balanced performance' },
  { id: 'gpt-4-turbo', name: 'GPT-4 Turbo', provider: 'OpenAI', costPerMin: 0.18, description: '128k context' },
  { id: 'gpt-3.5-turbo', name: 'GPT-3.5 Turbo', provider: 'OpenAI', costPerMin: 0.05, description: 'Legacy, fast' },
  // Anthropic
  { id: 'claude-3.5-sonnet', name: 'Claude 3.5 Sonnet', provider: 'Anthropic', costPerMin: 0.12, description: 'Best for coding' },
  { id: 'claude-3-opus', name: 'Claude 3 Opus', provider: 'Anthropic', costPerMin: 0.25, description: 'Most capable' },
  { id: 'claude-3-sonnet', name: 'Claude 3 Sonnet', provider: 'Anthropic', costPerMin: 0.10, description: 'Balanced' },
  { id: 'claude-3-haiku', name: 'Claude 3 Haiku', provider: 'Anthropic', costPerMin: 0.04, description: 'Fastest, cheapest' },
  // Google
  { id: 'gemini-2.0-flash', name: 'Gemini 2.0 Flash', provider: 'Google', costPerMin: 0.09, description: 'Next-gen fast' },
  { id: 'gemini-1.5-pro', name: 'Gemini 1.5 Pro', provider: 'Google', costPerMin: 0.14, description: '1M context' },
  { id: 'gemini-1.5-flash', name: 'Gemini 1.5 Flash', provider: 'Google', costPerMin: 0.06, description: 'Fast & efficient' },
  // Meta
  { id: 'llama-3.1-70b', name: 'Llama 3.1 70B', provider: 'Meta (via Groq)', costPerMin: 0.07, description: 'Open source' },
  { id: 'llama-3.1-8b', name: 'Llama 3.1 8B', provider: 'Meta (via Groq)', costPerMin: 0.03, description: 'Lightweight' },
  // Mistral
  { id: 'mistral-large', name: 'Mistral Large', provider: 'Mistral', costPerMin: 0.11, description: 'Flagship model' },
  { id: 'mistral-medium', name: 'Mistral Medium', provider: 'Mistral', costPerMin: 0.08, description: 'Balanced' },
  { id: 'mixtral-8x7b', name: 'Mixtral 8x7B', provider: 'Mistral', costPerMin: 0.05, description: 'MoE architecture' },
];

// Transcription Services
export const transcriptionServices = [
  { id: 'azure', name: 'Azure', description: 'Microsoft Azure Speech-to-Text', latency: 'Low' },
  { id: 'google', name: 'Google', description: 'Google Cloud Speech-to-Text', latency: 'Low' },
  { id: 'deepgram', name: 'Deepgram', description: 'Deepgram Nova-2', latency: 'Ultra-low' },
  { id: 'whisper', name: 'Whisper', description: 'OpenAI Whisper', latency: 'Medium' },
  { id: 'assembly', name: 'AssemblyAI', description: 'AssemblyAI Universal', latency: 'Low' },
  { id: 'aws', name: 'AWS Transcribe', description: 'Amazon Transcribe', latency: 'Low' },
  { id: 'rev', name: 'Rev AI', description: 'Rev AI Streaming', latency: 'Low' },
];

export const languages = [
  'English', 'Spanish', 'French', 'German', 'Italian', 'Portuguese', 
  'Chinese', 'Japanese', 'Korean', 'Arabic', 'Hindi', 'Russian', 'Uzbek',
  'Dutch', 'Polish', 'Turkish', 'Vietnamese', 'Thai', 'Indonesian',
  'Swedish', 'Norwegian', 'Danish', 'Finnish', 'Greek', 'Hebrew',
  'Czech', 'Romanian', 'Hungarian', 'Ukrainian', 'Malay', 'Filipino'
];

// Integration options
export const integrationOptions = [
  // CRM
  { id: 'salesforce', name: 'Salesforce', category: 'CRM', icon: '☁️', description: 'Sync contacts, log calls' },
  { id: 'hubspot', name: 'HubSpot', category: 'CRM', icon: '🧡', description: 'CRM integration' },
  { id: 'zoho', name: 'Zoho CRM', category: 'CRM', icon: '📘', description: 'Zoho CRM sync' },
  { id: 'pipedrive', name: 'Pipedrive', category: 'CRM', icon: '🎯', description: 'Sales pipeline' },
  { id: 'freshsales', name: 'Freshsales', category: 'CRM', icon: '🌱', description: 'Freshworks CRM' },
  // Automation
  { id: 'zapier', name: 'Zapier', category: 'Automation', icon: '⚡', description: '5000+ app connections' },
  { id: 'make', name: 'Make', category: 'Automation', icon: '🔄', description: 'Visual automation' },
  { id: 'n8n', name: 'n8n', category: 'Automation', icon: '🔗', description: 'Open-source automation' },
  // Calendar
  { id: 'google-calendar', name: 'Google Calendar', category: 'Calendar', icon: '📅', description: 'Appointment booking' },
  { id: 'calendly', name: 'Calendly', category: 'Calendar', icon: '📆', description: 'Scheduling automation' },
  { id: 'cal-com', name: 'Cal.com', category: 'Calendar', icon: '🗓️', description: 'Open-source scheduling' },
  { id: 'outlook', name: 'Outlook Calendar', category: 'Calendar', icon: '📧', description: 'Microsoft calendar' },
  // Communication
  { id: 'slack', name: 'Slack', category: 'Communication', icon: '💬', description: 'Team notifications' },
  { id: 'teams', name: 'Microsoft Teams', category: 'Communication', icon: '👥', description: 'Team collaboration' },
  { id: 'discord', name: 'Discord', category: 'Communication', icon: '🎮', description: 'Community notifications' },
  { id: 'twilio', name: 'Twilio', category: 'Communication', icon: '📱', description: 'SMS notifications' },
  // Database
  { id: 'airtable', name: 'Airtable', category: 'Database', icon: '📊', description: 'Database sync' },
  { id: 'google-sheets', name: 'Google Sheets', category: 'Database', icon: '📑', description: 'Spreadsheet logging' },
  { id: 'notion', name: 'Notion', category: 'Database', icon: '📝', description: 'Workspace integration' },
  // E-commerce
  { id: 'shopify', name: 'Shopify', category: 'E-commerce', icon: '🛒', description: 'Order management' },
  { id: 'woocommerce', name: 'WooCommerce', category: 'E-commerce', icon: '🛍️', description: 'WordPress e-commerce' },
  // Custom
  { id: 'webhook', name: 'Custom Webhook', category: 'Custom', icon: '🔧', description: 'Custom HTTP endpoints' },
  { id: 'api', name: 'Custom API', category: 'Custom', icon: '🔌', description: 'REST API integration' },
  { id: 'websocket', name: 'WebSocket', category: 'Custom', icon: '🌐', description: 'Real-time streaming' },
];

// Personality options for Response Behavior
export const personalityOptions = [
  { id: 'friendly', name: 'Friendly & Helpful', description: 'Warm, approachable tone' },
  { id: 'professional', name: 'Professional & Formal', description: 'Business-like, courteous' },
  { id: 'casual', name: 'Casual & Relaxed', description: 'Conversational, laid-back' },
  { id: 'empathetic', name: 'Empathetic & Caring', description: 'Understanding, supportive' },
  { id: 'enthusiastic', name: 'Enthusiastic & Energetic', description: 'Upbeat, excited' },
  { id: 'calm', name: 'Calm & Reassuring', description: 'Soothing, patient' },
  { id: 'authoritative', name: 'Authoritative & Expert', description: 'Confident, knowledgeable' },
];

// Default agent configuration
export const defaultAgentConfig = {
  name: 'New Voice Agent',
  type: 'outgoing',
  costPerMin: 0.105,
  languages: [],
  voiceProvider: 'google',
  voiceId: 'despina',
  voiceGender: 'female',
  voicePitch: 1.0,
  voiceSpeed: 1.0,
  llmModel: 'gpt-4.1-mini',
  transcriptionService: 'azure',
  welcomeMessage: '',
  welcomeMessageDynamic: false,
  welcomeMessageInterruptible: true,
  
  // Silence Handling (NEW)
  silenceHandling: {
    userIdleThreshold: 7,
    firstIdleMessage: "Are you still there?",
    firstIdleMessageDynamic: false,
    secondIdleMessage: "Would you like to continue our conversation?",
    lastIdleMessage: "I'll leave you for now. Have a nice day!",
  },
  
  // Response Behavior (NEW)
  responseBehavior: {
    fillerPhrasesEnabled: false,
    fillerPhrases: ["Let me check that for you...", "One moment please...", "Let me see..."],
    personality: 'friendly',
  },
  
  // End Call Rules (NEW)
  endCallRules: {
    maxCallDuration: 600,
    enableAutomaticEnding: false,
    automaticEndingMessage: "Thank you for calling. Goodbye!",
  },
  
  // Existing fields
  conversationalFlow: [
    { id: '1', title: 'Agent Identity & Purpose', enabled: true, content: '' },
    { id: '2', title: 'Identity Verification', enabled: true, content: '' },
    { id: '3', title: 'Security Confirmation', enabled: true, content: '' },
  ],
  maxCallDuration: 300,
  recordCalls: true,
  transferEnabled: false,
  transferNumber: '',
  transferTriggerPhrases: ['speak to a human', 'talk to someone', 'live agent', 'transfer me', 'real person'],
  transferMessage: "I'll transfer you to a live agent now. Please hold.",
  
  // Custom API Transfer (NEW)
  customApiTransfer: {
    enabled: false,
    endpoint: '',
    headers: {},
  },
  
  voicemailEnabled: false,
  voicemailMessage: '',
  assignedPhoneNumber: '',
  knowledgeBase: [],
  knowledgeBaseSize: 0,
  integrations: [],
  postCallWebhook: '',
  postCallSummary: true,
  postCallTranscript: true,
  postCallEmail: '',
  status: 'draft'
};
